import * as React from 'react';
const SvgArtboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.055 2.273C6 2.38 6 2.52 6 2.8V6H2.8c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219C2 6.38 2 6.52 2 6.8v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C2.38 8 2.52 8 2.8 8H6v8H2.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.219.218C2 16.38 2 16.52 2 16.8v.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C2.38 18 2.52 18 2.8 18H6v3.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218C6.38 22 6.52 22 6.8 22h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C8 21.62 8 21.48 8 21.2V18h8v3.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C18 21.62 18 21.48 18 21.2V18h3.2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C22 17.62 22 17.48 22 17.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 16 21.48 16 21.2 16H18V8h3.2c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219C22 7.62 22 7.48 22 7.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C21.62 6 21.48 6 21.2 6H18V2.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C17.62 2 17.48 2 17.2 2h-.4c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219C16 2.38 16 2.52 16 2.8V6H8V2.8c0-.28 0-.42-.054-.527a.5.5 0 0 0-.219-.219C7.62 2 7.48 2 7.2 2h-.4c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219M8 8v8h8V8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArtboard;
